import { render, staticRenderFns } from "./CamposIntegracao.vue?vue&type=template&id=118e3491&"
import script from "./CamposIntegracao.vue?vue&type=script&lang=js&"
export * from "./CamposIntegracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports